import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const blue = "#08306b";
const yellow = "#fffd33";
 
function BusinessPage() {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");

  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/admin");
  };

  // 🆕 Form submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/bars`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, description }),
      });

      if (!response.ok) throw new Error("Failed to create bar");
      const data = await response.json();
      console.log("Bar created:", data);
      
    } catch (err) {
      console.error("Error submitting business:", err.message);
    }
  };

  return (
    <div style={styles.container}>
      {/* Back Button */}
      <button style={styles.back} onClick={handleBack}>←</button>

      {/* Title */}
      <h1 style={styles.title}>Register Your Business</h1>
      <p style={styles.subtitle}>Tell us a bit about your place</p>

      {/* Form Layout Only */}
      <form style={styles.form} onSubmit={handleSubmit}>
        <label style={styles.label}>Email</label>
        <input 
          type="email" 
          placeholder="e.g. bar@email.com" 
          style={styles.input}
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
        />

        <label style={styles.label}>Business Name</label>
        <input 
          type="text" 
          placeholder="e.g. The Neon Bar" 
          style={styles.input} 
          value={name} 
          onChange={(e) => setName(e.target.value)}  
        />

        <label style={styles.label}>Background</label>
        <textarea
          placeholder="Describe your bar’s history, style, or vibe..."
          style={styles.textarea}
          value={description} // 🆕 Bind value
          onChange={(e) => setDescription(e.target.value)} // 🆕 Update state
        />

        <button type="submit" style={styles.submit}>Continue</button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    background: blue,
    // padding: "60px 20px",
    padding: "30px 15px", // smaller padding for phones
    fontFamily: "'Segoe UI', sans-serif",
    minHeight: "100vh",
    color: yellow,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  back: {
    alignSelf: "flex-start",
    fontSize: "24px",
    background: "none",
    border: "none",
    color: yellow,
    cursor: "pointer",
    marginBottom: "20px",
  },
  title: {
    fontSize: "28px",
    marginBottom: "8px",
    color: yellow,
  },
  subtitle: {
    fontSize: "16px",
    marginBottom: "40px",
    color: yellow,
  },
  form: {
    background: "#fff",
    borderRadius: "16px",
    padding: "30px",
    maxWidth: "420px",
    width: "85%",
    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  label: {
    color: blue,
    fontWeight: "500",
    fontSize: "15px",
    marginBottom: "-10px",
  },
  input: {
    padding: "12px",
    fontSize: "15px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    outline: "none",
  },
  textarea: {
    padding: "12px",
    fontSize: "15px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    height: "100px",
    resize: "none",
    outline: "none",
  },
  submit: {
    padding: "14px",
    backgroundColor: yellow,
    color: blue,
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default BusinessPage;
